<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
          label="上级中心">          
          <a-select placeholder="请选择上级中心" v-model="model.parentId" style="width: 200px" allowClear>
              <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item
            prop="code"
          label="编码">
          <a-input placeholder="请输入编码" v-model="model.code" />
        </a-form-model-item> -->
        <a-form-model-item
            prop="name"
          label="名称">
          <a-input placeholder="请输入名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item            
          label="中心管理员ID">
          <a-input placeholder="请输入中心管理员ID" v-model="model.userName" style="width: 80%" :disabled="true"/> <a-button icon="search" style="margin-left: 10px" @click="selectUserView()"></a-button>
        </a-form-model-item>
        <a-form-model-item
            prop="phone"
          label="联系电话">
          <a-input placeholder="请输入联系电话" v-model="model.phone" />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
    <Select-User-Modal ref="selectUserModal" :single="'1'" @selectFinished="selectUserOK"></Select-User-Modal>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import SelectUserModal from '../../../system/modules/SelectUserModal'

  export default {
    name: "CenterModal",
    components: { SelectUserModal },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          name:[baseRules.required],
          code:[baseRules.required],
          userName:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/management/center/add",
          edit: "/management/center/edit",
        },
        centerList:[],
      }
    },
    created () {      
    },
    methods: {
      selectUserView(){
        this.$refs.selectUserModal.visible = true;
      },
      selectUserOK(keys,records){
        const record = records[0]
        this.$set(this.model,'userId',record.id)
        this.$set(this.model,'userName',record.realname)
        this.$set(this.model,'phone',record.phone)
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.loadCenter()
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;              
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      loadCenter(){
        this.centerList=[{"id":'0',"name":"无"}]   
        getAction('/management/center/listAll',{status:'1'}).then(res=>{
          if(res.success){            
            this.centerList.push(...res.result)
          }else{
            this.$message.error('请求异常')
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>

</style>